import _pt from "prop-types";
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Visible = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$ariaHidden = _ref['aria-hidden'],
      ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
      className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 18 : _ref$size,
      title = _ref.title,
      titleId = _ref.titleId;
  return ___EmotionJSX("svg", {
    viewBox: "0 0 18 18",
    "aria-hidden": ariaHidden,
    className: className,
    height: size,
    ref: ref,
    role: "img",
    width: size,
    "aria-labelledby": titleId
  }, title === undefined ? ___EmotionJSX("title", {
    id: titleId
  }, 'Visible') : title ? ___EmotionJSX("title", {
    id: titleId
  }, title) : null, ___EmotionJSX("path", {
    fill: color,
    d: "M9 14c3.866 0 7-4.367 7-5s-3.134-5-7-5-7 4.102-7 5c0 .898 3.134 5 7 5zm0 2c-4.209 0-9-4.303-9-7s4.791-7 9-7c4.142 0 9 4.49 9 7s-4.858 7-9 7zm0-4a3 3 0 110-6 3 3 0 010 6z",
    fillRule: "evenodd"
  }));
});
Visible.propTypes = {
  'aria-hidden': _pt.bool,
  className: _pt.string,
  color: _pt.string,
  size: _pt.oneOf([12, 18, 24]),
  title: _pt.string,
  titleId: _pt.string
};
export default Visible;